import { useContext, useState, useMemo, useEffect } from 'react';
import { Avatar, Box, Card, Chip, Divider, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, TextField, Typography, useTheme } from '@mui/material';
import Compressor from 'compressorjs';
import {toast} from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { ButtonBasic, SelectGrupos, SelectUser, SelectPrioridadTkNubicom, SelectMotivoTicket, DateSingle, InputEditQuill, CardUploadFile, InputDropZoneComment, SelectCanalesSoftland, SelectSubMotivoBaja, SelectOtrosProveedores, SelectMotivoBajaTk, SelectNivelAdmTicket } from '../../components';
import { SocketContext } from '../../context/SocketContext';
import FechaFunction from '../../function/FechaFunction';
import TicketService from '../../services/tickets.service';
import AddIcon from '@mui/icons-material/Add';
import { showModal } from 'react-redux-modal-provider';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModalDirEntregaMulti from './ModalDirEntregaMulti';
import usePermisos from '../../hooks/usePermisos';

function ModalCrearTicketNubicomMasivos({show, hideModal,onGuardar}) {
    const handleClose = () => hideModal();
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const permisos = usePermisos();
    const { sockets } = useContext( SocketContext );
    const [files, setFiles] = useState([]);
    const [filesCompress, setFilesCompress] = useState([]);
    const [contactoCrm, setContactoCrm] = useState(null);
    const [arrSubMotivoBaja, setArrSubMotivoBaja] = useState([]);
    const [subMotivoBajaId, setSubMotivoBaja] = useState(null);
    const extensionPermitida = ['png','jpg','jpeg','svg','x-png'];
    const acceptInputFile = 'image/jpeg, image/png, image/jpg, image/svg, image/x-png, video/*,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const [formAll, setFormAll] = useState({
        titulo_tk: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        cuerpo_tk: {
            texto: null,
            textoErr: 'El cuerpo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        MotivoTicketId: {
            texto: null,
            textoErr: 'El motivo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        tipoId_uxt: {
            texto: null,
            textoErr: 'El destino es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        tipo_uxt: {
            texto: 'GRUPO',
            textoErr: 'El tipo de destino es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        prioridad_tk: {
            texto: 'NORMAL',
            textoErr: 'La prioridad es requerida',
            estadoErr: false,
            tipo: 'string'
        },
        subTipoTicketId_tk: {
            texto: null,
            textoErr: 'El sub tipo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        fechavencimiento_tk: {
            texto: null,
            textoErr: 'La fecha de vencimiento es requerida',
            estadoErr: false,
            tipo: 'string'
        },
        nivelAdmTkId_tk: {
            texto: null,
            textoErr: 'El nivel administrativo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        tipoTicketId_tk: {
            texto: null,
            textoErr: 'El tipo de ticket es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        arrContactos: {
            texto: [],
            textoErr: 'El listado de contacto es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        destinoDNI: {
            texto: null,
            textoErr: 'El destino es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        estadoTicket: {
            texto: 'tkAbierto',
            textoErr: 'El estado del ticket es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        codCanal_tk: {
            texto: null,
            textoErr: 'El canal es requerido',
            estadoErr: false,
            tipo: 'string'
        },
    })
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if((!value || value === '') && input !== 'telefono_c'){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const cambiarFecha = (date) =>{
        if(!date){
            date = 0;
        }
        const newDate = FechaFunction.addDaysDate(new Date(),date)
        onChangeForm(newDate, 'fechavencimiento_tk')
    }
    const onCompressImg = async(imgx) =>{
        const nombreCortado = imgx?.name?.split('.');
        let extension = nombreCortado[ nombreCortado?.length - 1 ];
        extension = extension?.toLowerCase();
        if(extensionPermitida.includes( extension ) ){
            setIsLoading(true);
            const img = new Compressor(imgx, {
                quality: 0.3,
                convertSize:2000000,
                success(result) {
                    result.id=imgx?.id
                    result.preview=imgx?.preview
                    setIsLoading(false);
                    setFilesCompress(old => [...old,result]);
                }
            })
        }else{
            setFilesCompress(old => [...old,imgx]);
        }
    }

    const onDeletedFile = (fileDele) =>{
        const filesRest = files.filter((filI)=> filI.id !== fileDele?.id)
        const filesCompRest = filesCompress.filter((filI)=> filI.id !== fileDele?.id)
        setFiles(filesRest)
        setFilesCompress(filesCompRest)
    }
    const onSubmit = async() =>{
      if(arrSubMotivoBaja?.length > 0 && !subMotivoBajaId){
        toast.error('Debe seleccionar un Sub-Motivo de baja.', {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }else{
        setIsLoading(true);
        const form = {
            propertys: 'nubicom',
            createdEmp_tk: 'NUBICOM',
            ticketIndv: true
        };
        if(subMotivoBajaId){
          form.subMotivoBajaId_tk = subMotivoBajaId;
        }
        let isOk = false;
        setIsLoading(true);
        const inputRequired = [
            'estadoTicket',
            'titulo_tk',
            'cuerpo_tk',
            'MotivoTicketId',
            'prioridad_tk',
            'subTipoTicketId_tk',
            'tipoTicketId_tk',
            'arrContactos',
            'codCanal_tk'
        ];
        if(formAll.estadoTicket.texto === 'tkAbierto'){
            inputRequired.push('fechavencimiento_tk')
            inputRequired.push('tipoId_uxt')
            inputRequired.push('tipo_uxt')
        }
        if(formAll?.nivelAdmTkId_tk?.texto === 10){
          inputRequired.push('motivoBajaTk_tk')
        }
        if((formAll?.MotivoTicketId?.texto === 33 || formAll?.MotivoTicketId?.texto === 48)){
          inputRequired.push('nivelAdmTkId_tk')
        }
        if((formAll?.motivoBajaTk_tk?.texto && formAll?.motivoBajaTk_tk?.texto?.toString()?.length > 0)){
          const motivoBajaValue = Number(formAll?.motivoBajaTk_tk?.texto);
          if([1, 8, 9, 10].includes(motivoBajaValue)){
            inputRequired.push('motivoBajaProveedorTk_tk')
          }
        }
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(filesCompress?.length > 0){
                form.filesCompress = filesCompress;
            }
            if(contactoCrm?.cuenta){
                form.cuentaId_txt = contactoCrm?.cuenta
            }else{
                form.contactoId_txt = contactoCrm?.id_c
            }
            await TicketService.register(form).then(()=>{
            if(formAll.estadoTicket.texto === 'tkAbierto'){
              sockets?.emit( 'newTicket',formAll?.destinoDNI?.texto);
            }
              if(onGuardar){
                onGuardar(true);
              }
              hideModal();
            })
            .catch(()=>{
              setIsLoading(false);
            })
            .finally(() => {
              setIsLoading(false);
            });
        }else{
          setIsLoading(false)
        }
      }
    }
    useEffect(() => {
        if(files.length > 0){
            files.forEach((filImg)=>{
                const existe = filesCompress.find((flCompress)=>flCompress.id === filImg.id)
                if(!existe){
                    onCompressImg(filImg)
                }
            })
        }
    }, [files])

    const styleBtnSelect = useMemo(() => ({
        border:1,
        borderColor: isDarkMode ? '#64B5F6' : '#15294b',
        color: isDarkMode ? '#64B5F6' : '#15294b',
        background: isDarkMode ? '#1F2A40' : 'white',
        '&:hover':{
            border:1,
            borderColor: isDarkMode ? '#64B5F6' : '#15294b',
            color: isDarkMode ? '#64B5F6' : '#15294b',
            background: isDarkMode ? '#2d3a52' : '#dfe2e6'
        }
    }),[isDarkMode]);

    const styleBtnNone = useMemo(() => ({
        background: isDarkMode ? '#2d3a52' : '#dfe2e6',
        boxShadow:0,
        color: isDarkMode ? '#b0bec5' : 'inherit',
        '&:hover':{
            border:1,
            borderColor: isDarkMode ? '#64B5F6' : '#15294b',
            color: isDarkMode ? '#64B5F6' : '#15294b',
            background: isDarkMode ? '#3d4a62' : '#dfe2e6'
        }
    }),[isDarkMode]);

    const styleInputHeight = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : 'gray',
            fontSize: 15
        },
        '& fieldset': {
            borderRadius: 2,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            height: 45
        },
        '& label':{
            marginTop: -0.5,
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                height: 45,
                borderColor: isDarkMode ? '#64B5F6' : 'gray',
                color: isDarkMode ? '#e0e0e0' : '#000'
            },
            '&:hover':{
                border: 1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#64B5F6' : 'gray',
                height: 40
            },
            '&.Mui-focused': {
                '&:hover':{
                border:0,
                height: 40
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 40
        },
        '& input': {
            color: isDarkMode ? '#e0e0e0' : '#000',
            backgroundColor: isDarkMode ? '#1F2A40' : '#fff'
        }
    }), [isDarkMode])
    const addArrContacto = (objArrContacto) =>{
        if(formAll.arrContactos.texto?.length > 0){
            const searchContacto = formAll.arrContactos.texto.find((arC)=> arC?.id_t && arC?.id_t === objArrContacto?.id_t)
            const searchContactoCuenta = formAll.arrContactos.texto.find((arC)=> arC?.cuentaContratoId_txt && arC?.cuentaContratoId_txt === objArrContacto?.cuentaContratoId_txt)
            if(!searchContacto && !searchContactoCuenta){
                const arrNew = formAll.arrContactos.texto || [];
                arrNew.push(objArrContacto)
                onChangeForm(arrNew,'arrContactos')
            }
        }else{
            const arrNew = formAll.arrContactos.texto || [];
            arrNew.push(objArrContacto)
            onChangeForm(arrNew,'arrContactos')
        }
    }
    const onDeleteContacto = (contactoSelect) =>{
        if(contactoSelect?.cuentaContratoId_txt){
            const filtroPreServicio = formAll.arrContactos.texto.filter((arC)=>arC?.id_t)
            const filtroArr = formAll.arrContactos.texto.filter((arC)=>arC?.cuentaContratoId_txt && arC?.cuentaContratoId_txt !== contactoSelect?.cuentaContratoId_txt)
            onChangeForm(filtroArr.concat(filtroPreServicio),'arrContactos')
        }
        if(contactoSelect?.id_t){
            const filtroServ = formAll.arrContactos.texto.filter((arC)=>arC?.cuentaContratoId_txt)
            const filtroArr = formAll.arrContactos.texto.filter((arC)=>arC?.id_t && arC?.id_t !== contactoSelect?.id_t)
            onChangeForm(filtroArr.concat(filtroServ),'arrContactos')
        }
    }
    const onOpenModalContacto = () =>{
        showModal(ModalDirEntregaMulti,{onGuardar: addArrContacto})
    }
    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth className='side'>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}} className='side'>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'start', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        Nuevos Tickets Masivos - NUBICOM
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent className='side'>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={4} md={3}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Estado del ticket:</Typography>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={formAll.estadoTicket.texto}
                                    onChange={(e) => onChangeForm(e.target.value,'estadoTicket')}
                                    row
                                >
                                    <FormControlLabel
                                        value="tkAbierto"
                                        control={ <Radio sx={{color: isDarkMode ? '#64B5F6' : '#000', '&.Mui-checked': {color: isDarkMode ? '#64B5F6' : '#1976d2'}}} />}
                                        label="Abierto"
                                        sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}
                                    />
                                    <FormControlLabel
                                        value="tkCerrado"
                                        control={ <Radio sx={{color: isDarkMode ? '#64B5F6' : '#000', '&.Mui-checked': {color: isDarkMode ? '#64B5F6' : '#1976d2'}}} /> }
                                        label="Cerrado"
                                        sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            {formAll.estadoTicket.texto === 'tkAbierto' && (
                                <>
                                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Seleccione el destinatario</Typography>
                                    <Box sx={{display: 'flex', justifyContent:'center',alignItems:'center', width:250,background: isDarkMode ? '#2d3a52' : '#dfe2e6',p:1,borderRadius:3,mb:2}}>
                                        {/* <ButtonBasic
                                            textButton='Personal'
                                            sx={formAll?.tipo_uxt?.texto === 'DNI' ? styleBtnSelect : styleBtnNone}
                                            onClick={()=>onChangeForm('DNI', 'tipo_uxt')}
                                        /> */}
                                        <ButtonBasic
                                            textButton='Grupo'
                                            sx={[{marginLeft:0},formAll?.tipo_uxt?.texto === 'GRUPO' ? styleBtnSelect : styleBtnNone]}
                                            onClick={()=>onChangeForm('GRUPO', 'tipo_uxt')}
                                        />
                                    </Box>
                                </>
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6} md={5}>
                            {formAll.estadoTicket.texto === 'tkAbierto' && (
                                <>
                                    { formAll.tipo_uxt.texto === 'DNI' ? (
                                        <Box sx={{width: '100%',mt:3}}>
                                            <SelectUser
                                                id="selectUser"
                                                filter="select"
                                                value={formAll.tipoId_uxt.texto}
                                                isInvalid={formAll.tipoId_uxt.estadoErr}
                                                onChange={(opt) => {
                                                    onChangeForm(opt.value, 'tipoId_uxt')
                                                    onChangeForm(opt.dni, 'destinoDNI')
                                                }}
                                            />
                                        </Box>
                                    ):(
                                        <Box sx={{width: '100%',mt:3}}>
                                            <SelectGrupos
                                                id="selectGrupo"
                                                value={formAll.tipoId_uxt.texto}
                                                isInvalid={formAll.tipoId_uxt.estadoErr}
                                                onChange={(opt) => {
                                                    onChangeForm(opt.value, 'tipoId_uxt')
                                                    onChangeForm(opt.value, 'destinoDNI')
                                                }}
                                            />
                                        </Box>
                                    )}
                                </>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Card sx={{background: isDarkMode ? '#2d3a52 !important' : '#fff !important',p:2,boxShadow:2}}>
                                <Box sx={{display: 'flex', justifyContent: 'space-between',alignItems: 'center'}}>
                                    <Box sx={{display: 'flex'}}>
                                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontSize:15}}>Contactos</Typography>
                                        {formAll.arrContactos.texto?.length > 0 && (
                                            <Chip label={formAll.arrContactos.texto?.length} size="small" sx={{background: isDarkMode ? '#3d4a62' : '#9d9ea4',color: isDarkMode ? '#e0e0e0' : 'inherit',width:23,height:23,ml:0.5}} />
                                        )}
                                    </Box>
                                    <ButtonBasic
                                        textButton='Agregar contacto'
                                        variant="wk"
                                        color='nextWhite'
                                        sx={{width: 170,fontWeight: 'bold', border:1,borderColor: '#0364ff'}}
                                        iconStart={<AddIcon sx={{color: '#0364ff'}} />}
                                        onClick={()=>onOpenModalContacto()}
                                    />
                                </Box>
                                <Box sx={{marginTop: 2}}>
                                    {formAll?.arrContactos?.texto?.length > 0 ?(
                                        <Grid container spacing={1}>
                                            {formAll?.arrContactos?.texto.map((arCont)=>(
                                                <Grid item xs={12} md={4} key={arCont?.cuentaContratoId_txt || arCont?.id_t}>
                                                    <Card sx={{background: isDarkMode ? '#1F2A40 !important' : '#fff !important',boxShadow: 3,p:1}}>
                                                        <Box sx={{display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
                                                            <Avatar sx={{background: isDarkMode ? '#3d4a62' : '#9d9ea4'}} />
                                                            <Box>
                                                                <Typography sx={{textAlign: 'start',color: isDarkMode ? '#e0e0e0' : '#000',fontSize: 10}}>{arCont?.nombre || '-'}</Typography>
                                                                <Typography sx={{textAlign: 'start',color: isDarkMode ? '#e0e0e0' : '#000'}}>{`${arCont?.cuentaContratoId_txt ? 'Servicio' : 'Pre-Servicio'}: ${arCont?.cuentaContratoId_txt || arCont?.id_t}`}</Typography>
                                                            </Box>
                                                            <IconButton
                                                                sx={{boxShadow: 3,color: isDarkMode ? '#e0e0e0' : '#000', '&:hover':{background: isDarkMode ? '#5c2a2a' : '#fce7e7',color: '#e01010'}}}
                                                                onClick={()=>onDeleteContacto(arCont)}
                                                            >
                                                                <DeleteOutlineOutlinedIcon />
                                                            </IconButton>
                                                        </Box>
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    ):(
                                        <Box sx={{background: isDarkMode ? '#1F2A40' : '#f6f8fc',minHeight: 30, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                            <Typography sx={{color: isDarkMode ? '#b0bec5' : '#808b9e', fontWeight: 'bold', textAlign: 'center'}}>Aun no se agregaron contactos</Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Card>
                        </Grid>
                        <Grid item xs={12} mt={0.5}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12, mb: 0.8}}>Titulo</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                sx={styleInputHeight}
                                value={formAll.titulo_tk.texto}
                                onChange={(e)=>onChangeForm(e.target.value, 'titulo_tk')}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} mt={0.5}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Motivo del Ticket</Typography>
                            <SelectMotivoTicket
                                id="MotivoTicketId"
                                value={formAll.MotivoTicketId.texto}
                                emp='nubicom'
                                isInvalid={formAll.MotivoTicketId.estadoErr}
                                onChange={(opt) => {
                                    onChangeForm(opt.value, 'MotivoTicketId');
                                    onChangeForm(opt.label, 'titulo_tk');
                                    onChangeForm('GRUPO', 'tipo_uxt');
                                    onChangeForm(opt.descripcion || '', 'cuerpo_tk');
                                    onChangeForm(opt.destino, 'tipoId_uxt');
                                    onChangeForm(opt.tipoTicket, 'tipoTicketId_tk');
                                    onChangeForm(opt.subTipoTicket, 'subTipoTicketId_tk');
                                    onChangeForm(opt.nivelAdm, 'nivelAdmTkId_tk');
                                    onChangeForm(opt.motivoBaja, 'motivoBajaTk_tk');
                                    cambiarFecha(opt.dayResolucion)
                                }}
                            />
                        </Grid>
                        {(formAll?.MotivoTicketId?.texto === 33 || formAll?.MotivoTicketId?.texto === 48) && (
                          <Grid item xs={12} sm={6} md={4} mt={0.5}>
                              <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Nivel Administrativo</Typography>
                              <SelectNivelAdmTicket
                                  subTipoTicket={formAll.subTipoTicketId_tk.texto}
                                  value={formAll.nivelAdmTkId_tk.texto}
                                  isInvalid={formAll.nivelAdmTkId_tk.estadoErr}
                                  onChange={(opt) => onChangeForm(opt.value,'nivelAdmTkId_tk')}
                              />
                              {formAll.nivelAdmTkId_tk.estadoErr && (
                                  <Typography sx={{color: 'red',fontSize:10}}>Campo obligatorio</Typography>
                              )}
                          </Grid>
                        )}
                        {formAll.nivelAdmTkId_tk.texto === 10 && (
                          <Grid item xs={12} sm={6} md={4} mt={0.5}>
                              <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Motivo de Baja</Typography>
                              <SelectMotivoBajaTk
                                  isDisabled={formAll.nivelAdmTkId_tk.texto !== 10}
                                  nivelAdmTk={4}
                                  value={formAll.motivoBajaTk_tk.texto}
                                  isInvalid={formAll.motivoBajaTk_tk.estadoErr}
                                  onChange={(opt) =>{
                                      onChangeForm(opt.value,'motivoBajaTk_tk')
                                      setArrSubMotivoBaja(opt?.arrSubMotivoBaja || [])
                                      setSubMotivoBaja(null);
                                      onChangeForm(null,'motivoBajaProveedorTk_tk')
                                  }}
                              />
                              {formAll.motivoBajaTk_tk.estadoErr && (
                                  <Typography sx={{color: 'red',fontSize:10}}>Campo obligatorio</Typography>
                              )}
                          </Grid>
                        )}
                        {formAll?.motivoBajaTk_tk?.texto && [1,8,9,10].includes(formAll?.motivoBajaTk_tk?.texto) &&(
                          <Grid item xs={12} sm={6} md={4} mt={0.5}>
                              <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Proveedor</Typography>
                              <SelectOtrosProveedores
                                  value={formAll.motivoBajaProveedorTk_tk.texto}
                                  isInvalid={formAll.motivoBajaProveedorTk_tk.estadoErr}
                                  onChange={(opt) =>{
                                      onChangeForm(opt.value,'motivoBajaProveedorTk_tk')
                                  }}
                              />
                              {formAll.motivoBajaProveedorTk_tk.estadoErr && (
                                  <Typography sx={{color: 'red',fontSize:10}}>Campo obligatorio</Typography>
                              )}
                          </Grid>
                        )}
                        {arrSubMotivoBaja?.length > 0 && (
                          <Grid item xs={12} md={4} mt={0.5}>
                              <Box sx={{display: 'flex', alignItems: 'start', justifyContent: 'center',flexDirection: 'column',width: '100%'}}>
                                  <Box sx={{width: '100%',p:0}}>
                                      <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',marginTop:0}}>Sub-Motivo de baja</Typography>
                                      <SelectSubMotivoBaja
                                          value={subMotivoBajaId}
                                          onChange={(opt)=>setSubMotivoBaja(opt.value)}
                                          filterId={arrSubMotivoBaja}
                                      />
                                  </Box>
                              </Box>
                          </Grid>
                        )}
                        <Grid item xs={12} sm={6} md={4} mt={0.5}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Prioridad</Typography>
                            <SelectPrioridadTkNubicom
                                value={formAll.prioridad_tk.texto}
                                isInvalid={formAll.prioridad_tk.estadoErr}
                                onChange={(opt) => onChangeForm(opt.value,'prioridad_tk')}
                            />
                        </Grid>
                        {formAll.estadoTicket.texto === 'tkAbierto' && (
                            <Grid item xs={12} sm={6} md={4}>
                                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Fecha de vencimiento</Typography>
                                <DateSingle
                                    value={formAll.fechavencimiento_tk.texto}
                                    onChange={(fecha)=> onChangeForm(fecha, 'fechavencimiento_tk')}
                                    minDate={new Date()}
                                    isDisabled={!permisos['fec_vencimiento_nubi']}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} sm={6} md={4} mt={0.5}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontSize:12}}>Canal</Typography>
                            <SelectCanalesSoftland
                                isInvalid={formAll.codCanal_tk.estadoErr}
                                value={formAll.codCanal_tk.texto}
                                onChange={(e)=>onChangeForm(e.value,'codCanal_tk')}
                            />
                            {formAll.codCanal_tk.estadoErr && (
                                <Typography sx={{color: 'red',fontSize:11,marginLeft:1}}>{formAll.codCanal_tk.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <InputEditQuill
                                template={formAll.cuerpo_tk.texto}
                                onChangeText={(text)=>onChangeForm(text, 'cuerpo_tk')}
                            />
                        </Grid>
                        { filesCompress?.length > 0 &&(
                            filesCompress.map((fil)=>(
                            <Grid item xs={12} sm={5.8} md={3.8} lg={3.8} ml={1} mt={{xs:1,lg:0}}>
                                <CardUploadFile item={fil} key={fil?.id} onDeleted={(e)=>onDeletedFile(e)} />
                            </Grid>
                            ))
                        )}
                    </Grid>
                    { filesCompress?.length < 5 &&(
                        <Box sx={{mt:2,mb:2,border: 2, borderColor: isDarkMode ? '#3d4a62' : '#a6aebb',borderStyle: 'dashed',mt:4,mb:1,borderRadius: 3,'&:hover':{border: 2,borderColor: isDarkMode ? '#64B5F6' : '#505f79',borderStyle: 'dashed'}}}>
                            <InputDropZoneComment
                                id="otImg"
                                onChange={(e)=>setFiles((old)=>[...old,...e])}
                                setFoto={setFiles}
                                accept={acceptInputFile}
                            />
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        sx={{mb:2}}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        variant='wk'
                        color='nextStep'
                        onClick={()=>onSubmit()}
                        sx={{mb:2}}
                        isLoading={isLoading}
                        isDisabled={formAll.arrContactos.texto?.length === 0 || !formAll.tipoTicketId_tk.texto || !formAll.subTipoTicketId_tk.texto || !formAll.tipoId_uxt.texto}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    );
}
export default ModalCrearTicketNubicomMasivos;